import { Router } from '@shared/domain/router/router.aggregate';
import { createBrowserHistory, BrowserHistory, To } from 'history';

const singletonInstance = createBrowserHistory();

export const historyImplementation: Router<BrowserHistory, To> = {
  browserRouter: singletonInstance,
  push: singletonInstance.push,
  back: singletonInstance.back
};
